import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search--sprite",
  "use": "search--sprite-usage",
  "viewBox": "0 0 27 27",
  "content": "<symbol viewBox=\"0 0 27 27\" id=\"search--sprite\">\n<circle cx=\"11.9331\" cy=\"11.9331\" r=\"9.76641\" transform=\"rotate(-45 11.9331 11.9331)\" />\n<path d=\"M18.1631 19.0112L24.6519 25.5002\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol